import { createFileRoute } from '@tanstack/react-router';
import AndroidPage from '@/pages/static/AndroidPage';

export const Route = createFileRoute('/android')({
  component: AndroidPage,
});
